import React, { useState, useEffect, useCallback } from 'react';

// Header button that toggles true browser full-screen via the Fullscreen API,
// hiding the address bar / tabs so only the app shows. Esc (or the button) exits.
// Includes webkit/ms fallbacks for older Edge/Safari.

const getFsElement = () =>
    document.fullscreenElement ||
    document.webkitFullscreenElement ||
    document.msFullscreenElement ||
    null;

export default function FullscreenToggle({ size = 26, color = 'var(--primary)' }) {
    const [isFs, setIsFs] = useState(!!getFsElement());

    useEffect(() => {
        const onChange = () => setIsFs(!!getFsElement());
        document.addEventListener('fullscreenchange', onChange);
        document.addEventListener('webkitfullscreenchange', onChange);
        document.addEventListener('msfullscreenchange', onChange);
        return () => {
            document.removeEventListener('fullscreenchange', onChange);
            document.removeEventListener('webkitfullscreenchange', onChange);
            document.removeEventListener('msfullscreenchange', onChange);
        };
    }, []);

    const toggle = useCallback(() => {
        if (getFsElement()) {
            const exit = document.exitFullscreen || document.webkitExitFullscreen || document.msExitFullscreen;
            if (exit) Promise.resolve(exit.call(document)).catch(() => {});
        } else {
            const el = document.documentElement;
            const req = el.requestFullscreen || el.webkitRequestFullscreen || el.msRequestFullscreen;
            if (req) Promise.resolve(req.call(el)).catch(() => {});
        }
    }, []);

    return (
        <button
            type="button"
            className="nav-link bell bell-link btn btn-link p-0"
            onClick={toggle}
            title={isFs ? 'Exit full screen (Esc)' : 'Full screen'}
            aria-label={isFs ? 'Exit full screen' : 'Enter full screen'}
            aria-pressed={isFs}
            style={{ background: 'none', border: 'none' }}
        >
            <i
                className={`las ${isFs ? 'la-compress' : 'la-expand'}`}
                style={{ fontSize: size, color, verticalAlign: 'middle' }}
            />
        </button>
    );
}
